import { Reducer } from 'redux';
import { DmvSearchActionTypes } from './actions';

// Type-safe initialState!
const initialState = {
  results: []
};

type IDmvSearchStoreState = Readonly<typeof initialState>;

const reducer: Reducer<IDmvSearchStoreState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case DmvSearchActionTypes.SEARCH: {
      let _state = { ...state };
      _state = { ..._state, results: action.value };
      return _state;
    }
    case DmvSearchActionTypes.GET_IMAGE: {
    //   stuff
    }
    default: {
      return state;
    }
  }
};

export default reducer;
